<template>
    <div :class="'item ' + type" @click.stop="$emit('click')">
        <FeatherIcon :name="icon" color="light" class="ico" />
        <div class="copy-m refg">
            {{ label }}
        </div>
    </div>
</template>

<script>
import FeatherIcon from '@/components/FeatherIcon'
export default {
    name: 'DContextMenuItem',
    components: { FeatherIcon },
    description: 'Context menu item',
    note: 'use this together with DContextMenu',
    props: {
        icon: {
            description: 'the icon that the item should use',
            type: String,
            required: true,
        },
        label: {
            description: 'the name of the label',
            type: String,
            required: true,
        },
        type: {
            description: 'can be either default or warning',
            type: String,
            default: 'default',
        },
    },
}
</script>

<style scoped lang="sass">
.item
    display: flex
    align-items: center
    height: $xl
    padding: 0 $xxs
    border-radius: 3px
    min-width: 110px
    box-sizing: border-box

    &.warning
        ::v-deep svg
          stroke: $red !important

        .copy-m
          color: $red !important

        &:hover
          background-color: rgba($red, 0.15) !important

    .refg
        margin-right: $s
        width: 100%


    ::v-deep svg
        transform: scale(0.9)

    &:hover
        background-color: $gray-2
        cursor: pointer

        .copy-m
            color: $neutral-4

        ::v-deep svg
            stroke: $neutral-4

    .copy-m
        color: $neutral-4
        font-weight: 500

    .ico
        margin-left: $xs
        margin-right: $xs
</style>
